import moment from 'moment'

/* eslint-disable */
Date.prototype.toISOString = function() {
	return moment(this).utcOffset(0, true).format()
}
/* eslint-enable */
